import { Avatar, Badge, Table, Tooltip } from 'antd';
import { FilterDropdownProps, TableRowSelection } from 'antd/es/table/interface';
import React from 'react'
import { filtersForStatusColumn, getDocumentColumns } from './columns/documentColumns'
import { DocumentFilterKey, IColumn, IDocument, IFolder } from 'interfaces'
import { useAppDispatch, useAppSelector } from 'store/hook';
import { setChoosenDocuments, setCurrentFolder, setDataDocumentTable, setSelectedDocument, setSelectedDocumentsIds, setSelectedRowKeys, setViewType, setExpandedFoldersCache, setHighlightedDocumentId, resetRowSelect } from 'store/slices/dataDocumentsSlice';
import { useFolderExpand } from 'hooks/useFolderExpand/useFolderExpand';
import TableLoader from '../Sceletons/TableLoader';
import { setMoreInfoHidden, setDocsSegment, setIsRSidebarCollapsed,
  setIsOpenMoveEntityModal, setIsOpenRenameEntityModal, setIsUploadingDocuments,
  setIsOpenShareEntityModal, setMovingDocument, setIsActiveContextMenu,
  setIsOpenConfidentConfirm,
  setIsOpenInfoEntityModal,
  defaultSidebarWidth,
} from 'store/slices/windowStateSlice';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import ContextMenu from '../ContextMenu/ContextMenu';
import { availableIconFormat, documnentIcons } from '../../helpers/documentIcons';
import Spinner from 'components/Spinner/Spinner';
import { useNavigate, useSearchParams } from 'react-router';
import { createChat, fetchSetSelectedChat } from 'store/reducers/chatCreator';
import getDateWithTimeZone from 'helpers/getDateWithTimeZone';
import { sortItems, sortHierarchical, collectNestedRows, unselectNestedRows } from 'helpers/sortTableItems'
import DocumentsFooter from './DocumentsFooter';
import Assets from 'assets/icons';
import { typesWithoutVersions } from 'helpers/filesExtensions';
import FilterDropdown from './FilterDropdown';
import DateRangeFilterDropdown from './DateRangeFilterDropdown';
import EmptyTableElement from './EmptyTableElement';
import { handleDownload, handleBulkDownloadArchive, handleMoveEntities, openContextModal, requestDeleteEntity, resetContextMenuField, fetchDocumentFilters, applyDocumentFilters } from 'store/reducers/documentsCreator';
import classes from './DocumentTable.module.scss'
import { sectionMatching } from 'components/DetailsComponent/DetailsComponent';

import FileStatuses from 'components/FileStatuses/FileStatuses';
import { buildDocumentViewUrl, serializeFiltersToUrl } from 'helpers/documentFiltersUrl';

type recordType = IDocument | IFolder;

type TableRecord = (IDocument | IFolder) & {
  _nestingLevel?: number;
};

function flattenIntoRows(
  items: TableRecord[],
  nestingLevel: number,
  expandedFolderIds: Set<string>,
  expandedFoldersCache: Record<string, TableRecord[]>,
): TableRecord[] {
  const result: TableRecord[] = [];

  for (const item of items) {
    result.push({
      ...item,
      _nestingLevel: nestingLevel,
    });

    const isFolderExpanded = item.type === 'folder' && item.id && expandedFolderIds.has(item.id);
    if (isFolderExpanded) {
      const children = expandedFoldersCache[item.id!] ?? [];
      const childRows = flattenIntoRows(children, nestingLevel + 1, expandedFolderIds, expandedFoldersCache);
      result.push(...childRows);
    }
  }

  return result;
}

export default function DocumentTable() {
  const [modifiedColumns, setModifiedColumns] = React.useState<IColumn[]>([]);
  const [modifiedData, setMofifiedData] = React.useState<TableRecord[]>([])
  const [delayClickTimer, setDelayClickTimer] = React.useState<NodeJS.Timeout>();
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = React.useState<boolean>(false);
  const [isDraggingOverRoot, setIsDraggingOverRoot] = React.useState<boolean>(false);
  const [activeSorter, setActiveSorter] = React.useState<{ field: string; order: 'ascend' | 'descend' } | null>(null);

  const {
    loadingFolderIds,
    expandedFolderIds,
    toggleFolderExpand,
    buildFolderPath,
  } = useFolderExpand();
  
  const { dataDocumentTable, documents, folders, filesForDownloading, selectedRowKeys,
    isLoadingDocuments, currentFolder, selectedDocument, selectedFolder, selectedDocumentsIds,
    expandedFoldersCache, appliedFilters, statusFilterOptions, highlightedDocumentId, choosenDocuments
  } = useAppSelector(store => store.documents);
  const { isLoadingProcess, isDeletingDocuments, isUploadingDocuments, messageApi, isActiveContextMenu } = useAppSelector((store) => store.windowState);
  const { isLoadingUserPermissions, userData, isLoadingUserData, userPermissions } = useAppSelector((store) => store.userData);
  const { userFoldersPermissions } = useAppSelector((store) => store.permissions);
  const { dataRoom, isLoadingRoom } = useAppSelector((state) => state.dataRoom);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { t, i18n } = useTranslation();  

  const isLoadingRooms = isLoadingRoom || isLoadingUserData || isLoadingDocuments || isLoadingUserPermissions || !userFoldersPermissions;
  const needToDisplayFooter = Boolean(selectedRowKeys.length);
  const footerHeight = 45;
  const currentFooterHeight = needToDisplayFooter ? footerHeight : 0;
  const tokensForDownloading = filesForDownloading.map(file => file?.token || '');
  const sideBarWidth = Number(localStorage.getItem('sideBarWidth')) || defaultSidebarWidth;
  const prevViewedDocId = localStorage.getItem('prevViewedDocId');

  const privateRooms = ['85141b41-bc64-4623-b293-2ba4bbea0e6f', '143d9fd4-96b7-46e8-819f-9515a04eaff9']
  const referenceOrder = [
      'Введение.pdf',
      'Введение - курс "5 Шагов к Грин Карте"',
      'Список стран участвующих и не участвующих в лотерее.pdf',
      'Часть 1.pdf',
      'Часть 1. Курс "5 Шагов к Грин Карте"',
      'Часть 2.pdf',
      'Часть 2 курса "5 Шагов к Грин Карте"',
      'Часть 3.pdf',
      'Часть 3 курса "5 Шагов к Грин Карте"',
      'Часть 4.pdf',
      'Часть 4. Курс "5 Шагов к Грин Карте"',
      'Часть 5.pdf',
      'Часть 5. Видео Инструкции. Курс "5 Шагов к Грин Карте"',
      'Распространенные ошибки.pdf',
      'Часто задаваемые вопросы .pdf'
  ];

  React.useEffect(() => {
    if (!highlightedDocumentId || isLoadingDocuments || modifiedData.length === 0) return;

    const timer = setTimeout(() => {
      const tableBody = document.querySelector(`.${classes.tableArea} .ant-table-body`);
      if (!tableBody) return;

      const row = tableBody.querySelector(`tr[data-row-key*="${highlightedDocumentId}"]`) as HTMLElement;      
      if (!row) {
        dispatch(setHighlightedDocumentId(null));
        return;
      }

      row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      row.classList.add(classes.highlightFlash);
      row.addEventListener('animationend', () => {
        row.classList.remove(classes.highlightFlash);
      }, { once: true });

      dispatch(setHighlightedDocumentId(null));
    }, 400);

    return () => clearTimeout(timer);
  }, [highlightedDocumentId, isLoadingDocuments, modifiedData, dispatch]);
  
  React.useEffect(() => {
    if (isActiveContextMenu) return;

    const next = { ...expandedFoldersCache };
    let hasChanges = false;
    for (const [folderId, items] of Object.entries(next)) {
      const hasOpen = items.some((item) => item.isOpenContextMenu);
      if (hasOpen) {
        next[folderId] = items.map((item) => ({ ...item, isOpenContextMenu: false }));
        hasChanges = true;
      }
    }
    if (hasChanges) dispatch(setExpandedFoldersCache(next));

    onSelectRowChange(selectedRowKeys, choosenDocuments);
  }, [isActiveContextMenu, expandedFoldersCache, dispatch]);

  const buildFlatTableData = React.useCallback(
    (items: TableRecord[]): TableRecord[] =>
      flattenIntoRows(items, 0, expandedFolderIds, expandedFoldersCache),
    [expandedFolderIds, expandedFoldersCache],
  );

  const showDetails = (entity: any, e?: React.MouseEvent<HTMLElement>, tab?: string) => {    
    if(entity?.status === 0) return;    
    e?.stopPropagation();
    dispatch(setSelectedDocument(entity));
    dispatch(setDocsSegment('view'))
    dispatch(setViewType('Document'));
    navigate(buildDocumentViewUrl(window.location.pathname, searchParams, tab || 'view', entity.id));
  };  

  const detailsModalHandle = (info: any, e?: React.MouseEvent<HTMLElement>, tab?: string) => {
    dispatch(openContextModal({
      entity: info,
      openTargetModal: () => showDetails(info, e, tab)
    }));
    tab && dispatch(setDocsSegment(tab))
  };

  const onFilterDropdownOpenChange = (open: boolean) => setIsFilterDropdownOpen(open);

  React.useEffect(() => {
    if (dataRoom?.id) {
      dispatch(fetchDocumentFilters(dataRoom.id));
    }
  }, [dataRoom?.id, dispatch]);

  const handleTableChange = (_pagination: any, filters: Record<string, any>, sorter: any) => {
    if (sorter?.field) {
      setActiveSorter(sorter.order ? { field: sorter.field, order: sorter.order } : null);
    }

    if (!dataRoom?.id) return;

    const newStatus = ([...(filters?.status as DocumentFilterKey[] || [])]).sort();
    const currentStatus = ([...(appliedFilters.status || [])]).sort();
    if (JSON.stringify(newStatus) === JSON.stringify(currentStatus)) return;

    const nextStatus = (filters?.status as DocumentFilterKey[] || []);
    setSearchParams(serializeFiltersToUrl(searchParams, { status: nextStatus }), { replace: true });

    dispatch(applyDocumentFilters({
      roomId: dataRoom.id,
      folderId: currentFolder[0]?.id || null,
      appliedFilters,
      rawFilters: filters,
    }));
  };

  React.useEffect(()=> {
    const documentColumns = getDocumentColumns(t);
    const customColumns = documentColumns?.map((col: IColumn) => ({
      ...col,
      filterIcon: (col.dataIndex === 'name' || col.dataIndex === 'upload_at') && ((filtered: boolean) => (
        <Assets.SearchIcon className={filtered ? classes.primaryFilter : classes.greyIcon} />
      )),
      filters: col.dataIndex === 'status' && filtersForStatusColumn(statusFilterOptions, t),
      filteredValue: col.dataIndex === 'status'
        ? (appliedFilters.status ?? null)
        : col.dataIndex === 'upload_at'
          ? (appliedFilters.dateFrom ? [appliedFilters.dateFrom] : null)
          : col.dataIndex === 'name'
            ? (appliedFilters.name ? [appliedFilters.name] : null)
            : null,
      filterDropdown: col.dataIndex === 'name' && !dataRoom?.is_blocked
        ? ({ confirm, clearFilters, close }: FilterDropdownProps) => (
            <FilterDropdown
              confirm={confirm}
              clearFilters={clearFilters!}
              close={close}
            />
          )
        : col.dataIndex === 'upload_at'
          ? ({ confirm, clearFilters, close }: FilterDropdownProps) => (
              <DateRangeFilterDropdown confirm={confirm} clearFilters={clearFilters!} close={close} />
            )
          : undefined,
      filterDropdownProps: {
        onOpenChange: onFilterDropdownOpenChange
      },
      render: (value: any, info: any) => col.key === 'name'
        ? <ContextMenu
          key={info.key}
          entity={info}
          t={t}
          renderFunc={() => renderCell({value, info, col})}
          moveModalOpenHandle={() => dispatch(openContextModal( {entity: info, openTargetModal: () => dispatch(setIsOpenMoveEntityModal(true)) }))}
          renameModalHandle={() => dispatch(openContextModal({ entity: info, openTargetModal: () => dispatch(setIsOpenRenameEntityModal(true)) }))}
          shareModalHandle={() => dispatch(openContextModal({ entity: info, openTargetModal: () => dispatch(setIsOpenShareEntityModal(true)) }))}
          detailsModalHandle={(tab?: string) => detailsModalHandle(info, undefined, tab)}
          // newVersionHandle={() => dispatch(openContextModal({ entity: info, openTargetModal: () => dispatch(setIsOpenNewVersionModal(true)) }))}
          onSectionIconClick={onSectionIconClick}
          onDownloadFile={handleDownloadFile}
          onDownloadArchive={handleDownloadArchive}
          onBulkDownload={handleBulkDownload}
          onBulkDownloadAsArchive={handleDownloadArchive}
          openFolder={openFolder}
          onBulkDelete={handleBulkDelete}
          openInfoModal={() => dispatch(openContextModal({ entity: info, openTargetModal: () => dispatch(setIsOpenInfoEntityModal(true)) }))}
        />
        : renderCell({value, info, col}),
    }))
    setModifiedColumns(customColumns);
    const baseItems = privateRooms.includes(dataRoom?.id!) ? sortItems(dataDocumentTable, referenceOrder) : dataDocumentTable;

    if (activeSorter) {
      const { sortedItems, sortedCache } = sortHierarchical(
        baseItems,
        expandedFoldersCache,
        activeSorter.field,
        activeSorter.order,
      );
      const displayData = flattenIntoRows(sortedItems as TableRecord[], 0, expandedFolderIds, sortedCache);
      setMofifiedData(displayData);
    } else {
      const displayData = buildFlatTableData(baseItems as TableRecord[]);
      setMofifiedData(displayData);
    }
  },[documents, i18n.language, folders, selectedDocument, selectedFolder, dataDocumentTable, isFilterDropdownOpen, filesForDownloading, buildFlatTableData, loadingFolderIds, statusFilterOptions, appliedFilters, activeSorter]);

  const getSectionKeyByValue = (section: string) => {
    const sectionName = section?.split('.').reverse()[0];
    for (let key in sectionMatching) {
      if (sectionMatching[key as keyof typeof sectionMatching] === sectionName) {
        return key;
      }
    }
  };

  const onSectionIconClick = (section: string, info: any) => {    
    if(info?.status === 0) return;
    dispatch(setSelectedDocument(info));
    dispatch(setViewType('Document'));
    dispatch(resetContextMenuField({}));

    const modalSection = getSectionKeyByValue(section) || 'view';
    const rSection = section.split('.')?.reverse()[0];
    navigate(buildDocumentViewUrl(window.location.pathname, searchParams, modalSection, info.id));

    let neededPermission: boolean;
    if (rSection === 'agreement') {
      neededPermission = userPermissions.can_edit_agreement;
    } else if (rSection === 'signing') {
      neededPermission = userPermissions.can_manage_signing;
    } else {
      neededPermission = true;
    }    

    section && neededPermission && dispatch(setIsRSidebarCollapsed({
      collapsed: false,
      entity: section,
      width: 350,
    }));
  };

  const getNestingClass = (level: number): string => {
    const safeLevel = Math.min(level, 30);
    return classes[`nestingLevel${safeLevel}`] || '';
  };

  const renderCell = (props: any) => {
    const { value, info, col } = props;
    const fileType = info.type?.toLowerCase();
    const icon = availableIconFormat.includes(fileType) ? fileType : 'default';
    const isConfidential = info?.is_confidential;
    const nestingLevel: number = info._nestingLevel || 0;
    const isFolder = info.type === 'folder';
    const isExpanded = isFolder && info.id && expandedFolderIds.has(info.id);
    const isLoadingFolder = isFolder && info.id && loadingFolderIds.has(info.id);
    const hasFolderContent = isFolder && ((info?.documents_amount || 0) !== 0 || (info?.subfolders && info.subfolders.length > 0));
    if(col.key === 'upload_at'){
      return value && getDateWithTimeZone(value, userData?.date_format!);
    };

    if(col.key === 'status'){
      return (
        <div className={prevViewedDocId === info.id ? classes.viewedActive : 'null'}>
          <FileStatuses
          file={info}
          onSectionIconClick={onSectionIconClick}
        />
        </div>
      );
    };

    if(col.key === 'name'){
      if (info.status === 0) {
        return (
          <div className={cn(classes.rowWrap, getNestingClass(nestingLevel))}>
            <div className={classes.expandSpacer} />
            <div className={classes.icon}>
              <Avatar
                className={classes.avatar}
                icon={documnentIcons[icon as keyof typeof documnentIcons]}
              />
            </div>
            {value}
            <Spinner />
          </div>
        );
      } else {
        return (
          <div className={cn(classes.rowWrap, getNestingClass(nestingLevel))}>
            {nestingLevel > 0 && (
              <div className={classes.indentGuides}>
                {Array.from({ length: Math.min(nestingLevel, 30) }, (_, i) => (
                  <div key={i} className={cn(classes.indentGuide, classes[`indentGuide${i}` as keyof typeof classes])} />
                ))}
              </div>
            )}
            {hasFolderContent ? (
              <button
                className={cn(classes.expandButton, isExpanded && classes.expandButtonActive)}
                onClick={(e) => toggleFolderExpand(info.id!, e)}
                onDoubleClick={(e) => e.stopPropagation()}
              >
                {isLoadingFolder
                  ? <Spinner size={14} width='12px' />
                  : (
                    <Assets.PlusIcon
                      className={cn(classes.expandIcon, isExpanded && classes.expandIconOpen)}
                    />
                  )
                }
              </button>
            ) : (
              <div className={classes.expandSpacer} />
            )}

            <div className={classes.icon}>
              <Avatar
                className={classes.avatar}
                icon={documnentIcons[icon as keyof typeof documnentIcons]}
              />
              {isConfidential && <div className={cn(classes.confidentialIcon, 'confidential')}>
                <Tooltip title={t('Documents.table.confidential')}>
                  <span><Assets.ShieldIcon /></span>
                </Tooltip>
              </div>}
            </div>
            <div className={classes.blockName}>
              <div>{value}</div>
              {!typesWithoutVersions.includes(fileType) && info?.version_count > 1 && (
                <div
                  className={classes.versionCnt}
                  onClick={(e) => detailsModalHandle(info, e, 'versions')}
                >
                  { `${t('Documents.table.version_count')}: ${info?.version_count - 1}` }
                </div>
              )}
              {info.type === 'folder' && Number(info?.documents_amount) > 0 && (
                <Tooltip title={t('Documents.table.filesInFolder')} mouseEnterDelay={0.3}>
                  <div className={classes.folderFilesCount}>
                    <Assets.FileIcon />
                    <span>{info.documents_amount}</span>
                  </div>
                </Tooltip>
              )}
            </div>
            {(tokensForDownloading.includes(info?.token) || tokensForDownloading.includes(info?.id)) && 
              <Tooltip title={t('Documents.table.downloading')} mouseEnterDelay={.3}>
                <div><Spinner size={18} width={'32px'}/></div>
              </Tooltip>
            }
          </div>
        );
      };
    };

    if(col.key === 'chats' && fileType !== 'folder'){
      const onClickChat = async (e: React.MouseEvent<HTMLDivElement>) => {
        if(info?.status === 0) return;

        dispatch(setIsUploadingDocuments(true));
        const chatInfo = await dispatch(
          createChat({
            data: {
              entity_type: 0,
              entity_id: info.id,
              members_ids: dataRoom?.available_users
                ?.map(({ id }) => id)
                .filter((id): id is string => Boolean(id)) || [],
              title: info.name,
              room_id: dataRoom?.id!,
            },
            ownerId: userData?.id!,
          })
        );
        dispatch(setViewType('Document'));
        dispatch(setDocsSegment('chat'));
        dispatch(fetchSetSelectedChat((chatInfo.payload as any).chat));
        navigate(buildDocumentViewUrl(window.location.pathname, searchParams, 'chat', info.id));
        dispatch(setSelectedDocument(info));
        dispatch(setIsUploadingDocuments(false));
      };
      
      return (
        info.unviewed_amount && info.unviewed_amount > 0
          ? <Badge onClick={onClickChat} count={info.unviewed_amount} className={cn(classes.scaleHover, classes.newMessages)} />
          : info.message_amount && info.message_amount > 0
            ? <Badge onClick={onClickChat} count={info.message_amount} className={cn(classes.scaleHover, classes.allMessages)} />
            : <div onClick={onClickChat} className={cn(classes.scaleHover, classes.iconChat)}><Assets.ChatIcon /></div>
      );
    };
    
    return value;
  };

  const onSelectRowChange = (newSelectedRowKeys: React.Key[], selectedRows: any[]) => {
    const selectedNestedRows = collectNestedRows(selectedRows, expandedFoldersCache);
    
    let allSelectedRows = [...selectedRows, ...selectedNestedRows];
    const seen = new Set();
    let uniqueAllSelectedRows = allSelectedRows.filter(item => {
      if (seen.has(item.id)) return false;
      seen.add(item.id);
      return true;
    });
    
    const result = unselectNestedRows(newSelectedRowKeys, selectedRowKeys, choosenDocuments, uniqueAllSelectedRows);
    if (result.abort) {
      return;
    } else {
      uniqueAllSelectedRows = result.rows;
    }

    const withTokens = uniqueAllSelectedRows.filter(({ status }) => status !== 0);
    const documentsKeys = withTokens.map(({ key }) =>  key);
    
    const documentsKeysAndPermissions = withTokens.map(
      ({ key, permissions, extension, size, name, subfolders, documents_amount, folder_id, parent_folder_id, id, type }) =>
      ({ key, permissions, extension, size, name, subfolders, documents_amount, folder_id, parent_folder_id, id, type })
    );
    const selectedFilesIds = uniqueAllSelectedRows.filter(({type}) => type !== 'folder').map(({ id }: any) => id);

    dispatch(setSelectedDocumentsIds(selectedFilesIds));
    dispatch(setChoosenDocuments(documentsKeysAndPermissions));
    dispatch(setSelectedRowKeys(documentsKeys));
  };
  
  const openContextMenu = (event: React.MouseEvent<HTMLTableRowElement | HTMLDivElement>, entity: IDocument | IFolder) => {
    const maxPageX = event.pageX;
    event.preventDefault();
    const isAlreadySelected = entity.key && selectedRowKeys.includes(entity.key);
    if(!isAlreadySelected) dispatch(resetRowSelect());
      
    dispatch(setIsActiveContextMenu(true));
    dispatch(setDataDocumentTable(dataDocumentTable.map(element => ({
      ...element,
      isOpenContextMenu: element.id === entity.id ? true : false,
      pageX: element.id === entity.id ? maxPageX - (sideBarWidth + 100) : 0,
    }))));

    const next = { ...expandedFoldersCache };
    let hasChanges = false;
    for (const [folderId, items] of Object.entries(next)) {
      const updatedItems = items.map(item => {
        const isTarget = item.id === entity.id;
        if (isTarget || item.isOpenContextMenu) {
          hasChanges = true;
          return {
            ...item,
            isOpenContextMenu: isTarget ? true : false,
            pageX: isTarget ? maxPageX - (sideBarWidth + 100) : 0,
          };
        }
        return item;
      });
      if (hasChanges) {
        next[folderId] = updatedItems;
      }
    }
    if (hasChanges) dispatch(setExpandedFoldersCache(next));
  }

  const rowSelection: TableRowSelection<any> = {
    selectedRowKeys,
    onChange: onSelectRowChange,
  };

  const addDragClass = (target: any) => {
    const element = target as HTMLElement;
    element.classList.add(classes.onDrag);
  }

  const removeDragClass = (target: any) => {
    const element = target as HTMLElement;
    element.classList.remove(classes.onDrag);
  }

  const handleDragStart = (event: React.DragEvent<HTMLTableRowElement>, record: recordType) => {
    dispatch(setMovingDocument(true));
    addDragClass(event.target);
    event.dataTransfer.items.add(JSON.stringify(record), 'application/json');
  }

  const handleDragLeave = (event: React.DragEvent<HTMLTableRowElement>) => {
    removeDragClass(event.target);
  }

  const handleDragEnd = (event: React.DragEvent<HTMLTableRowElement>) => {
    dispatch(setMovingDocument(false));
    removeDragClass(event.target);
    setIsDraggingOverRoot(false);
  }

  const handleDragOver = (event: React.DragEvent<HTMLTableRowElement>) => {
    dispatch(setMovingDocument(true));
    event.preventDefault();
    event.stopPropagation();
    addDragClass(event.target);
  }

  const handleDrop = (event: React.DragEvent<HTMLTableRowElement>, record_id: string) => {
    dispatch(setMovingDocument(false));
    event.preventDefault();
    event.stopPropagation();
    removeDragClass(event.target);

    const data = event.dataTransfer.items;
    data[0]?.getAsString((s) => {
      const droppedFile = JSON.parse(s) as recordType;

      const isAlreadyInFolder = (droppedFile as IDocument).folder_id === record_id;
      if (isAlreadyInFolder) return;

      const isDrop = selectedDocumentsIds.includes(droppedFile.id!)
      const includedFiles = isDrop ? selectedDocumentsIds : [droppedFile.id!];
      dispatch(handleMoveEntities({
        selectedFiles: includedFiles,
        folder_id: [record_id!],
        t,
        navigate,
        topLevelFolder: (currentFolder && currentFolder[0]) ? currentFolder[0]?.id! : record_id!,
      }));
    });
  };

  const handleDropOnRoot = (event: React.DragEvent<HTMLDivElement>) => {
    dispatch(setMovingDocument(false));
    event.preventDefault();
    setIsDraggingOverRoot(false);

    if ((event.target as HTMLElement).closest('tr')) return;

    const data = event.dataTransfer.items;
    data[0]?.getAsString((s) => {
      const droppedFile = JSON.parse(s) as recordType;
      if (!droppedFile?.id) return;

      const isAlreadyInRoot = !('folder_id' in droppedFile) || (droppedFile as IDocument).folder_id == null;
      if (isAlreadyInRoot) return;

      const isDrop = selectedDocumentsIds.includes(droppedFile.id!);
      const includedFiles = isDrop ? selectedDocumentsIds : [droppedFile.id!];
      dispatch(handleMoveEntities({
        selectedFiles: includedFiles,
        folder_id: ['null'],
        t,
        navigate,
        topLevelFolder: 'null',
      }));
    });
  };

  const onRowClick = (file: IDocument) => {
    
  };

  const handleDownloadArchive = (entity?: any) => {    
    dispatch(handleBulkDownloadArchive({ t, messageApi: messageApi!, entity }));
  };

   const handleDownloadFile = async (entity: IDocument | IFolder, version: IDocument, isPdf?: boolean) => {
    dispatch(handleDownload({
      is_webview: !!isPdf,
      language: i18n.language,
      t,
      messageApi: messageApi!,
      targetDocument: { entity, version },
    }));
  };

  const handleBulkDownload = (isPdf?: boolean) => {
    dispatch(handleDownload({ is_webview: !!isPdf, language: i18n.language, t, messageApi: messageApi! }));
  };

  const openFolder = (record: any) => {
    dispatch(setSelectedDocument(null));
    dispatch(setMoreInfoHidden(true));
    const fullPath = buildFolderPath(record);
    const nextFolderState = [...currentFolder, ...fullPath];
    dispatch(setCurrentFolder(nextFolderState));
    navigate(`/room/${dataRoom?.id}/documents/${record.id}`);
    localStorage.setItem('previousFolderPath', JSON.stringify(nextFolderState));
  }

  const handleBulkDelete = async (entity : IDocument | IFolder) => {
    await dispatch(requestDeleteEntity({entity}))
  };

  if (isLoadingRooms) {
    return (
      <TableLoader padding={'0px'} height={window.innerHeight - 84} margin={'-20px 0px 0px 0px'}/>
    )
  };  

  return (
    <div
      className={cn(
        classes.tableArea,
        (isLoadingProcess || isDeletingDocuments || isUploadingDocuments) ? classes.tableRowLoading : 'empty',
        isDraggingOverRoot && classes.tableAreaOnDrag,
      )}
      onDragOver={(e) => {
        e.preventDefault();
        setIsDraggingOverRoot(true);
      }}
      onDragLeave={(e) => {
        if (!e.currentTarget.contains(e.relatedTarget as Node)) {
          setIsDraggingOverRoot(false);
        }
      }}
      onDrop={handleDropOnRoot}
    >
      <Table
        onChange={handleTableChange}
        loading={false}
        locale={{emptyText:
          <EmptyTableElement
            currentFooterHeight={currentFooterHeight}
          />
        }}
        className={classes.table}
        dataSource={modifiedData!}
        columns={modifiedColumns}
        scroll={modifiedData[0] && {
          y: `calc(100vh - ${(144 + currentFooterHeight)}px)`,
        } }
        pagination={false}
        size='small'
        expandable={{
          expandIcon: () => null
        }}
        rowSelection={rowSelection}
        rowClassName={(record) => {
          const tableRecord = record as TableRecord;
          const isNested = Boolean(tableRecord._nestingLevel && tableRecord._nestingLevel > 0);
          return cn(
            isLoadingProcess || isDeletingDocuments || isUploadingDocuments || record.status === 0
              ? classes.tableRowLoading
              : classes.tableRow,
            isNested && classes.nestedRow,
          );
        }}
        onRow={(record, idx: any) => {
          const onViewClick = async (event: any) => {
            localStorage.removeItem('prevViewedDocId');
            if(record.status === 0) return; 
            if (record.type === 'youtube') {
              window.open(record.description, '_blank')
              event.stopPropagation();
              clearTimeout(delayClickTimer);
              return
            }
            if (record.type === 'folder') {
              clearTimeout(delayClickTimer);
              openFolder(record);  
              return;
            }
            event.stopPropagation();
            clearTimeout(delayClickTimer);

            if(record.confident_document?.length){
              dispatch(setIsOpenConfidentConfirm(true))
              return;
            };
            dispatch(setViewType('Document'));
            dispatch(setSelectedDocument(record));
            navigate(buildDocumentViewUrl(window.location.pathname, searchParams, 'view', record.id));
            dispatch(setIsRSidebarCollapsed({ collapsed: true, entity: '', width: 0 }));
          }

          const onDelayRowClick = () => {
            clearInterval(delayClickTimer);
            setDelayClickTimer(setTimeout(() => {
              onRowClick(record);
            }, 250));
          };

          const onDropFolder = (event: any) => handleDrop(event, record.id);
          const onDropFile = (event: any) => handleDrop(event, record?.folder_id);

          const onDrop = record.type === 'folder' ? onDropFolder : onDropFile;
          return{
            onDrop,
            onDragLeave: handleDragLeave,
            onDragStart: (event: any) => handleDragStart(event, record),
            onDragEnd: handleDragEnd,
            onDragOver:  record.type === 'folder' ? handleDragOver : undefined,
            onClick:  onDelayRowClick,
            onDoubleClick: onViewClick,
            onContextMenu:(e) => openContextMenu(e, record),        
            onMouseLeave: () => dispatch(resetContextMenuField({})),    
            draggable: record.type !== 'folder',
          }
        }}
      />

      {needToDisplayFooter && <DocumentsFooter
        handleDownloadArchive={handleDownloadArchive}
      />}
    </div>
  )
};
